module.exports = __webpack_public_path__ + "./img/truck.svg";